import React from 'react';
import { useTranslation } from 'react-i18next';

import { General } from 'icons/untitledui';
import * as Styled from 'shiftNotes/styles/InstantReflex/InstantReflexLoadingCard.style';

export default function InstantReflexLoadingCard(): JSX.Element {
  const { t } = useTranslation('pageShiftNotes');
  return (
    <Styled.Card role="status" aria-live="polite">
      <Styled.Content>
        <Styled.Icon aria-hidden="true">
          <General.Loading02 />
        </Styled.Icon>
        <Styled.Label>{t('instantReflex.loading')}</Styled.Label>
      </Styled.Content>
    </Styled.Card>
  );
}
